import type { Dict } from "../core.js";
import type { shell as vi } from "../vi/shell.js";

export const shell: Dict<typeof vi> = {
  menuBack: "Back",
  menuClose: "Close submenu",
  menuExpand: "Expand group",
  navigation: "Main navigation",
  configuration: "Integration setup",
  skipContent: "Skip to main content",
  openMenu: "Toggle navigation",
  preferences: "Preferences",
  changePassword: "Change password",
  "group.integrations": "Integrations",
  "nav.providers": "Providers",
  "nav.integrationAccounts": "Platform accounts",
  "nav.integrationConnections": "Connections",
  "nav.integrationBindings": "App bindings",
  "nav.integrationRouting": "Email routing",
  "nav.integrationEntitlements": "Entitlements & commerce",
  "nav.featureReadiness": "Feature readiness",
  "nav.integrationHealth": "Integration status",
  "nav.labTingee": "Tingee",
  "nav.labBankHub": "Bank Hub",
  "nav.labEinvoice": "E-invoice",
  "group.general": "Customer support",
  "group.lab": "Labs",
  "group.metrics": "Business",
  "group.metricsHint": "All apps — pick an app inside the page",
  "group.apps": "Apps",
  "group.system": "System",
  "group.admin": "Admin",

  "nav.attention": "Needs attention",
  "nav.support": "Support",
  "nav.overview": "Overview",
  "nav.integrations": "Integrations",
  "nav.ai": "AI",
  "nav.labIndex": "Available labs",
  "nav.labFixtures": "Test data",
  "nav.labRuns": "Test runs",
  "nav.audience": "Users",
  "nav.subscriptions": "Subscriptions",
  "nav.revenue": "Revenue",
  "nav.planMapping": "Plan mapping",
  "nav.feedback": "Feedback",
  "nav.sources": "Data sources",
  "nav.reliability": "Reliability",
  "nav.cost": "Infrastructure cost",
  "nav.mailStatus": "Mail",
  "nav.mailProviders": "Mail providers",
  "nav.dependencies": "Dependencies",
  "nav.products": "Products",
  "nav.ops": "Operations",
  "nav.staff": "Staff",
  "nav.teams": "Teams",
  "nav.ownership": "Responsibilities",
  "nav.appHome": "App overview",
  "nav.shopBankTransfer": "Transfer confirmation",
  "nav.sharedHub": "Shared hub",
  "nav.partnerReport": "Partner report",
  "nav.appLinks": "App links",
  "nav.shopIntegrationCards": "Customer integration visibility",
  "nav.customerWorkspaces": "Workspaces",
  "nav.customerUsers": "Users",
  "nav.invoiceQuota": "Invoice quota",
  "nav.resale": "Service resale",
  "nav.acquisitionOps": "VN invoice fetch server",

  attentionNone: "Nothing needs attention",
  attentionCount: "{count} unresolved items — including acknowledged ones",
  logout: "Sign out",
  appStatusTitle: "{app} — {status}",
  appNotLive: "Source not connected",
  language: "Language",

  "theme.menu": "Theme",
  "theme.light": "Light",
  "theme.dark": "Dark",
  "theme.studio": "Studio",
  "theme.retro": "Retro",
  "theme.system": "System",
  "theme.lightAbbr": "Lgt",
  "theme.darkAbbr": "Drk",
  "theme.studioAbbr": "Stu",
  "theme.retroAbbr": "Ret",
  "theme.systemAbbr": "Sys",

  sessionUnreachable: "Cannot reach the Bube HQ server. This is a network or server error — not a sign-in problem.",
  sessionRetry: "Retry",
  sessionChecking: "Checking session…",

  searchPlaceholder: "Search products or services…",
  searchAria: "Search the catalog",
  searchEmpty: "No matches. The catalog is loaded from source code — anything not declared there can't be found yet.",
  searchProduct: "product · {slug}",
  searchService: "service · {slug}",
};
